import styled, { css } from 'styled-components/macro';

export const TabsContainer = styled.div`
  display: flex;
  gap: 0;
  width: 100%;
`;

export const Tab = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 40px;
  white-space: nowrap;
  cursor: pointer;
  text-align: center;
  padding: 0 16px;
  transition: border-bottom-color 150ms;

  ${({ theme, $isSelected }) => css`
    border-bottom: 1px solid
      ${$isSelected ? theme.colors.primary[600] : theme.colors.gray[300]};

    &:hover {
      p {
        color: ${$isSelected
          ? theme.colors.primary[600]
          : theme.colors.primary[500]};
      }
    }
  `}
`;
